import { render, staticRenderFns } from "./services-list.vue?vue&type=template&id=1e050188&scoped=true&"
import script from "./services-list.vue?vue&type=script&lang=js&"
export * from "./services-list.vue?vue&type=script&lang=js&"
import style0 from "./services-list.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./services-list.vue?vue&type=style&index=1&id=1e050188&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e050188",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fservices_v3%2Fservices-list.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/lang/search.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fservices_v3%2Fservices-list.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "@/lang/confirmations.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fservices_v3%2Fservices-list.vue"
if (typeof block2 === 'function') block2(component)
import block3 from "@/lang/services.json?vue&type=custom&index=3&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fservices_v3%2Fservices-list.vue"
if (typeof block3 === 'function') block3(component)
import block4 from "./services-list.vue?vue&type=custom&index=4&blockType=i18n"
if (typeof block4 === 'function') block4(component)

export default component.exports